'use client';

import { useEffect, useRef } from 'react';

export function LandingParallaxBackground({
  src,
  speed = 0.08,
  className = '',
}: {
  src: string;
  speed?: number;
  className?: string;
}) {
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let frame = 0;
    const update = () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => {
        if (elementRef.current) {
          elementRef.current.style.transform = `translate3d(0, ${window.scrollY * speed}px, 0) scale(1.08)`;
        }
      });
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    return () => {
      window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, [speed]);

  return (
    <div
      ref={elementRef}
      aria-hidden="true"
      className={`absolute inset-x-0 -top-20 bottom-0 -z-20 bg-cover bg-center bg-no-repeat will-change-transform ${className}`}
      style={{
        backgroundImage: `url('${src}')`,
        transform: 'translate3d(0, 0, 0) scale(1.08)',
      }}
    />
  );
}
